import { render, staticRenderFns } from "./Popup2.vue?vue&type=template&id=ae83e9ca&scoped=true&"
import script from "./Popup2.vue?vue&type=script&lang=js&"
export * from "./Popup2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae83e9ca",
  null
  
)

export default component.exports